import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';
import _ from 'lodash';
export const UPDATE_LOADING_STATUS = 'FETCH_MENU_SUCCESS';
export const FETCH_APPMANGE_DATA_LIST = 'FETCH_APPMANGE_DATA_LIST';
export const GET_BLACKLISTNULL_LIST = 'GET_BLACKLISTNULL_LIST';

/**
 * 修改页面加载loading
 * @param {*} param
 */
export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

/**
 * 获取标准面板数据列表
 * @param {*} param
 */
export function fetchPanelList(param) {
  return (dispatch, getState) => {
    const defaultParam = {
      pageStart: 0,
      pageSize: 10,
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/v3/panel/gated/page`, {
      method: 'POST',
      body: req,
    });
    fetchData.then((res) => {
      dispatch(updateLoadingStatus(false));
      if (res.code == 200) {
        let list = _.get(res, 'data', []);
        const total = _.get(res, 'page.total', 0);

        // 给返回的数据根据页数添加序号
        list = list.map((item, index) => {
          item.index = index + 1 + (req.pageStart * req.pageSize);
          return item;
        });

        // 判断未搜索时，是否有数据
        const { allRnPanelStatus, rnName = '', panelName = '', firstCategory = '', secondCategory = '' } = param;
        if (allRnPanelStatus && rnName == '' && panelName == '' && firstCategory == '' && secondCategory == '') {
          dispatch({
            type: GET_BLACKLISTNULL_LIST,
            isDataList: list.length > 0,
          });
        }
        dispatch({
          type: FETCH_APPMANGE_DATA_LIST,
          dataList: list || [],
          dataListTotal: total,
        });
      } else {
        message.error(intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      dispatch(updateLoadingStatus(false));
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 新增面板
 * @param {*} param
 */
export function addPanel(param, callback, failback) {
  let newParams = param;
  newParams.pversion = "V1.0.0"
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/panel/add', 'POST', newParams, callback, failback)
  };
}

/**
 * 修改面板
 * @param {*} param
 */
export function editPanel(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/panel/update', 'PUT', param, callback, failback)
  };
}

/**
 * 升级面板
 * @param {*} param
 */
export function upgradePanel(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/panel/upgrade', 'PUT', param, callback, failback)
  };
}

/**
 * 灰度/发布面板
 * @param {*} param
 */
export function publishPannel(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/panel/gatedRelease', 'POST', param, callback, failback)
  };
}



/**
 * 删除面板
 * @param {*} param
 */
export function deletePannel(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/panel/delete', 'DELETE', param, callback, failback)
  };
}

/**
 * 下架面板
 * @param {*} panelId
 */
export function downPannel(panelId = '', callback, failback) {
  return (dispatch, getState) => {
    const formData = new FormData();
    formData.append('panelId', panelId);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/v3/panel/out`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        message.success(intl.get('commmon.operate.success'));
        callback && callback();
      } else {
        failback && failback();
        message.error(intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      failback && failback();
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 封装接口函数
 * @param {*} param
 */
function fetchFun(url, method, param, callback, failback) {
  const defaultParam = {}
  const req = Object.assign({}, defaultParam, param);
  const fetchData = new FetchData(`${util.requestPath}${url}`, {
    method: method,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/json'
    },
    body: req,
  });
  fetchData.then((res) => {
    if (res.code == 200) {
      message.success(intl.get('commmon.operate.success'));
      callback && callback(res.data || {});
    } else if (res.code == "50020") {
      failback && failback();
      message.error(intl.get('commmon.operate.upgradeing'));
    } else {
      failback && failback();
      message.error(intl.get('commmon.operate.retry'));
    }
  }).catch(e => {
    failback && failback();
    message.error(intl.get('commmon.operate.retry'));
  })
}
